// extracted by mini-css-extract-plugin
export default {"button":"CloseDCConfirmDialog_button__haokR","actionBtn":"CloseDCConfirmDialog_actionBtn__cXsE1"};